import { RETURN_TO_PARAM } from "@arcadeai/ui-kit/utils/auth-redirect";
import {
  createFileRoute,
  Outlet,
  redirect,
  stripSearchParams,
} from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { RootLoader } from "@/components/custom/root-loader";
import { sessionQueryOptions } from "@/lib/auth-client";

const searchParamsSchema = z.object({
  help: fallback(z.boolean(), false).default(false),
});

const defaultValues = {
  help: false,
};

export const Route = createFileRoute("/_authenticated")({
  validateSearch: zodValidator(searchParamsSchema),
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
  pendingComponent: RootLoader,
  beforeLoad: async (ctx) => {
    const session =
      await ctx.context.queryClient.ensureQueryData(sessionQueryOptions);
    if (!session) {
      throw redirect({
        to: "/login",
        search: {
          [RETURN_TO_PARAM]: ctx.location.href,
        },
      });
    }
  },
  component: () => <Outlet />,
});
